<template>

    <m-edit1/>

    <m-wallet-1 v-bind='{...{},...{}}' :style='""' class="m-wallet-1" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":6,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="mt-5" ></m-form-single-1></template>
                </m-wallet-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mWallet1 from '@moeinmdn/miw-alpha-components/src/package/Wallet/Wallets/Wallet1/Wallet1'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mWallet1,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
